module.exports = "<p>\n  view-time-component works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/view-time-component/view-time-component.component.html
// module id = ./src/app/shared/modules/view-time-component/view-time-component.component.html
// module chunks = main